export enum SystemMessage {
  UNKNOWN_ERROR = "Something's wrong",
  DO_NOT_PERMISSION = "Không có quyền truy cập",
  SUCCESS = "Thành Công",
  DELETE_SUCCESS = "Xóa Thành Công", 
}
